<template>
    <div class="md:max-w-screen-xl w-full mx-auto">
        <div class="stats-table-shell" v-if="scopedProjectData">
            <div class="stats-table-scroll">
                <table-lite
                    :is-slot-mode="true"
                    :is-static-mode="true"
                    :is-loading="loading"
                    :columns="columns"
                    :rows="scopedProjectData.participants"
                    :messages="messages"
                    :total="scopedProjectData.participants.length"
                    :sortable="sortable"
                >
                    <template v-slot:attendance_status="data">
                        <div v-if="data.value.response_adults" class="indicator">
                            <span
                                v-if="data.value.response_menu_type == 'vegetarian'"
                                class="indicator-item badge badge-primary shadow-md"
                            >
                                <font-awesome-icon icon="fa-solid fa-leaf" />
                            </span>

                            <div class="join">
                                <div
                                    class="join-item badge badge-primary badge-lg"
                                    v-if="data.value.attendance_status == 'Attending'"
                                >
                                    <font-awesome-icon icon="fa-solid fa-user-check" />
                                    <span class="pl-2">Participa</span>
                                </div>
                                <div
                                    class="join-item badge bg-blue-500 text-white badge-lg"
                                    v-if="data.value.attendance_status == 'Attending'"
                                >
                                    <span
                                        ><font-awesome-icon
                                            class=""
                                            icon="fa-solid fa-users"
                                        />{{ data.value.response_adults }}</span
                                    >
                                </div>
                                <div
                                    class="join-item badge bg-blue-600 text-white badge-lg"
                                    v-if="data.value.response_children"
                                >
                                    <span v-if="data.value.response_children"
                                        ><font-awesome-icon
                                            class=""
                                            icon="fa-solid fa-children"
                                        />{{ data.value.response_children }}</span
                                    >
                                </div>
                                <div
                                    class="join-item badge bg-blue-700 text-white badge-lg"
                                    v-if="data.value.response_accommodation"
                                >
                                    <font-awesome-icon icon="fa-solid fa-bed" />
                                </div>
                            </div>
                        </div>
                        <div
                            class="badge badge-accent badge-lg"
                            v-if="data.value.attendance_status == 'Not Attending'"
                        >
                            <font-awesome-icon icon="fa-solid fa-user-slash" />
                            <span class="pl-2">Nu Participa</span>
                        </div>
                    </template>

                    <template v-slot:email_sent_time="data">
                        <div class="flex items-center gap-2">
                            <div
                                class="tooltip cursor-default pl-1"
                                :data-tip="`Invitatie trimisa prin Email la ${data.value.email_sent_time}`"
                                v-if="data.value.email_sent_time"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-envelope-circle-check"
                                    class="text-primary text-lg"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatia nu a fost trimisa`"
                                v-else
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-envelope"
                                    class="text-base-300 text-lg"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default pl-1"
                                :data-tip="`Invitatie trimisa prin SMS la ${data.value.sms_sent_time}`"
                                v-if="data.value.sms_sent_time"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-mobile-screen"
                                    class="text-primary text-lg"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatia nu a fost trimisa`"
                                v-else
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-mobile-screen"
                                    class="text-base-300 text-lg"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default pl-1"
                                :data-tip="`Invitatie trimisa prin WhatsApp la ${data.value.whatsapp_shared_time}`"
                                v-if="data.value.whatsapp_shared_time"
                            >
                                <font-awesome-icon
                                    icon="fa-brands fa-whatsapp"
                                    class="text-green-500 text-lg"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatia nu a fost trimisa prin WhatsApp`"
                                v-else
                            >
                                <font-awesome-icon
                                    icon="fa-brands fa-whatsapp"
                                    class="text-base-300 text-lg"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatie vizualizata la ${data.value.opened_time}`"
                                v-if="data.value.opened_time"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-eye"
                                    class="text-primary text-lg"
                                />
                            </div>
                            <div v-else>
                                <font-awesome-icon
                                    icon="fa-solid fa-eye-slash"
                                    class="text-base-300 text-lg"
                                />
                            </div>
                        </div>
                    </template>

                    <template v-slot:actions="data">
                        <div class="flex items-center gap-1">
                            <button
                                @click="openResponseModal(data.value)"
                                class="btn btn-square btn-xs btn-outline btn-primary tooltip tooltip-left"
                                data-tip="Răspuns manual"
                            >
                                <font-awesome-icon icon="fa-solid fa-clipboard-check" />
                            </button>
                            <button
                                v-if="data.value.attendance_status && !data.value.form_unlocked"
                                @click="unlockForm(data.value)"
                                class="btn btn-square btn-xs btn-outline btn-warning tooltip tooltip-left"
                                data-tip="Formular blocat — apasă pentru a debloca"
                            >
                                <font-awesome-icon icon="fa-solid fa-lock" />
                            </button>
                            <button
                                v-else-if="data.value.attendance_status && data.value.form_unlocked"
                                class="btn btn-square btn-xs btn-outline border-success text-success no-animation tooltip tooltip-left pointer-events-none"
                                data-tip="Formularul este deblocat"
                                tabindex="-1"
                            >
                                <font-awesome-icon icon="fa-solid fa-lock-open" />
                            </button>
                            <button
                                v-else
                                class="btn btn-square btn-xs btn-outline border-base-300 text-base-300 no-animation tooltip tooltip-left pointer-events-none"
                                data-tip="Niciun răspuns încă"
                                tabindex="-1"
                            >
                                <font-awesome-icon icon="fa-solid fa-minus" />
                            </button>
                        </div>
                    </template>
                </table-lite>
            </div>
        </div>
        <p
            v-if="scopedProjectData.participants.length === 0"
            class="text-gray-500 mt-4"
        >
            Nu s-a gasit nici un invitat pentru acest proiect.
        </p>

        <!-- Manual Response Modal -->
        <ModalComponent :is-open="isResponseModalOpen" @close="closeResponseModal">
            <h3 class="font-bold text-lg">Răspuns Manual</h3>
            <p class="text-sm text-gray-500 mb-2">
                Adaugă sau modifică răspunsul în numele invitatului
                <span class="font-semibold">{{ responseParticipant.recipient_surname }} {{ responseParticipant.recipient_name }}</span>.
            </p>
            <button
                @click="closeResponseModal"
                class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            >
                ✕
            </button>
            <div class="py-4 space-y-4">
                <div>
                    <label class="label"><span class="label-text font-semibold">Participare</span></label>
                    <select v-model="responseForm.attendance_status" class="select select-bordered w-full">
                        <option value="Attending">Participă</option>
                        <option value="Not Attending">Nu participă</option>
                    </select>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label class="label"><span class="label-text font-semibold">Adulți</span></label>
                        <input v-model.number="responseForm.response_adults" type="number" min="0" class="input input-bordered w-full" />
                    </div>
                    <div>
                        <label class="label"><span class="label-text font-semibold">Copii</span></label>
                        <input v-model.number="responseForm.response_children" type="number" min="0" class="input input-bordered w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label class="label"><span class="label-text font-semibold">Meniu</span></label>
                        <select v-model="responseForm.response_menu_type" class="select select-bordered w-full">
                            <option value="standard">Standard</option>
                            <option value="vegetarian">Vegetarian</option>
                        </select>
                    </div>
                    <div>
                        <label class="label"><span class="label-text font-semibold">Cazare</span></label>
                        <select v-model="responseForm.response_accommodation" class="select select-bordered w-full">
                            <option :value="0">Nu</option>
                            <option :value="1">Da</option>
                        </select>
                    </div>
                </div>
                <div>
                    <label class="label"><span class="label-text font-semibold">Mesaj</span></label>
                    <textarea v-model="responseForm.response_message" class="textarea textarea-bordered w-full" rows="2"></textarea>
                </div>
                <div class="flex justify-end gap-3 pt-2">
                    <button class="btn" @click="closeResponseModal">Anulează</button>
                    <button class="btn btn-primary" @click="submitManualResponse()">Salvează răspuns</button>
                </div>
            </div>
        </ModalComponent>

        <div v-if="loading">
            <LoadingComponent></LoadingComponent>
        </div>
    </div>
</template>

<script>
import TableLite from 'vue3-table-lite';
import LoadingComponent from './LoadingComponent.vue';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import ModalComponent from '@/components/ModalComponent.vue';
import { mapGetters } from 'vuex';

export default {
    props: ['projectId'],
    components: { TableLite, LoadingComponent, ModalComponent },
    data() {
        return {
            isDeleteModalOpen: false,
            selectedDeleteParticipant: {},
            isEditModalOpen: false,
            editedParticipant: {},
            selectedProject: null,
            isResponseModalOpen: false,
            responseParticipant: {},
            responseForm: {
                attendance_status: 'Attending',
                response_adults: 1,
                response_children: 0,
                response_menu_type: 'standard',
                response_accommodation: 0,
                response_message: '',
            },
            pageOptions: [
                { value: 100, text: 100 },
                { value: 150, text: 150 },
                { value: 200, text: 200 },
            ],
            columns: [
                {
                    label: 'Nume',
                    field: 'recipient_surname',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Prenume',
                    field: 'recipient_name',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Status Participare',
                    field: 'attendance_status',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Status Invitatie',
                    field: 'email_sent_time',
                    width: '12%',
                    sortable: false,
                },
                {
                    label: 'Mesaj',
                    field: 'response_message',
                    width: '15%',
                    sortable: true,
                },
                {
                    label: 'Vizualizari',
                    field: 'invitation_views',
                    width: '8%',
                    sortable: true,
                },
                {
                    label: 'Actiuni',
                    field: 'actions',
                    width: '8%',
                    sortable: false,
                },
            ],
            sortable: {
                order: 'recipient_name',
                sort: 'desc',
            },
            messages: {
                pagingInfo:
                    'Se afiseaza {0} din {1} rezultate | Total {2} rezultate',
                pageSizeChangeLabel: 'Numar randuri afisate: ',
                gotoPageLabel: ' Mergi la pagina: ',
                noDataAvailable: 'Nu sunt disponibile informatii',
            },
        };
    },
    setup() {
        // Get toast interface
        const toast = useToast();

        // Make it available inside methods
        return { toast };
    },
    mounted() {},
    computed: {
        ...mapGetters([
            'projects',
            'plan',
            'loading',
            'scopedProjectData',
            'stats',
        ]),
    },
    methods: {
        openResponseModal(participant) {
            this.responseParticipant = participant;
            this.responseForm = {
                attendance_status: participant.attendance_status || 'Attending',
                response_adults: participant.response_adults || 1,
                response_children: participant.response_children || 0,
                response_menu_type: participant.response_menu_type || 'standard',
                response_accommodation: participant.response_accommodation || 0,
                response_message: participant.response_message || '',
            };
            this.isResponseModalOpen = true;
        },
        closeResponseModal() {
            this.isResponseModalOpen = false;
        },
        async submitManualResponse() {
            try {
                const jwtToken = localStorage.getItem('userToken');
                const res = await axios.post(
                    '/api/index.php?endpoint=adminUpdateResponse',
                    {
                        project_id: this.responseParticipant.project_id,
                        unique_parameter: this.responseParticipant.unique_parameter,
                        ...this.responseForm,
                    },
                    { headers: { Authorization: `Bearer ${jwtToken}` } }
                );
                if (res.data.success) {
                    this.toast.success('Răspuns salvat cu succes!');
                    this.closeResponseModal();
                    const projectId = this.projectId;
                    this.$store.dispatch('fetchProjectUsers', { projectId, options: {}, participants: true });
                } else {
                    this.toast.error(res.data.message || 'Eroare la salvarea răspunsului.');
                }
            } catch (e) {
                this.toast.error('Eroare la salvarea răspunsului.');
            }
        },
        async unlockForm(participant) {
            try {
                const jwtToken = localStorage.getItem('userToken');
                const res = await axios.post(
                    '/api/index.php?endpoint=unlockInvitationForm',
                    {
                        project_id: participant.project_id,
                        unique_parameter: participant.unique_parameter,
                    },
                    { headers: { Authorization: `Bearer ${jwtToken}` } }
                );
                if (res.data.success) {
                    this.toast.success(`Formularul pentru ${participant.recipient_surname} ${participant.recipient_name} a fost deblocat.`);
                } else {
                    this.toast.error(res.data.message || 'Eroare la deblocarea formularului.');
                }
            } catch (e) {
                this.toast.error('Eroare la deblocarea formularului.');
            }
        },
    },
};
</script>

<style>
.stats-table-shell {
    border: 1px solid #dbe3ef;
    border-radius: 1.1rem;
    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
    padding: 0.7rem;
}

.stats-table-scroll {
    width: 100%;
    overflow-x: auto;
}

.stats-table-shell .vtl-table {
    min-width: 860px;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #d8e2f0;
    border-radius: 0.9rem;
    overflow: visible;
}

.stats-table-shell .vtl-table .vtl-thead .vtl-thead-th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: linear-gradient(180deg, #334155 0%, #1e293b 100%);
    color: #f8fafc;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 0.7rem;
    font-weight: 800;
    border-bottom: 1px solid #1e293b;
    padding: 0.7rem 0.75rem;
}

.stats-table-shell .vtl-table tbody td {
    padding: 0.75rem;
    border-bottom: 1px solid #e8eef7;
    color: #1e293b;
    vertical-align: middle;
    font-size: 0.85rem;
}

.stats-table-shell .vtl-table tbody tr:nth-child(odd) td {
    background: #f8fbff;
}

.stats-table-shell .vtl-table tbody tr:nth-child(even) td {
    background: #ffffff;
}

.stats-table-shell .vtl-table tbody tr:hover td {
    background: #eaf3ff;
}

.stats-table-shell .vtl-table tbody tr:last-child td {
    border-bottom: 0;
}

.stats-table-shell .vtl-table thead th:nth-child(6),
.stats-table-shell .vtl-table tbody td:nth-child(6) {
    text-align: right;
}

.stats-table-shell .vtl-paging {
    border-top: 1px solid #dbe3ef;
    padding-top: 0.6rem;
    margin-top: 0.2rem;
    color: #475569;
    font-size: 0.79rem;
}

.stats-table-shell .vtl-paging select {
    border: 1px solid #cbd5e1;
    border-radius: 0.35rem;
    background: #ffffff;
}

@media (max-width: 640px) {
    .stats-table-shell {
        padding: 0.45rem;
        border-radius: 0.85rem;
    }

    .stats-table-shell .vtl-table {
        min-width: 760px;
    }

    .stats-table-shell .vtl-table .vtl-thead .vtl-thead-th,
    .stats-table-shell .vtl-table tbody td {
        padding: 0.6rem 0.58rem;
    }
}
</style>
